"use client";

import React from "react";
import { useTranslations, useLocale } from "next-intl";
import { formatNumberByLocale } from "@/utils/numberFormatter";

type Props = {
  stateLabel: string;
  villages: string | number;
  partners: string | number;
  superPartners: string | number;
  /** Hide the Super Partners row (default: shown). */
  showSuperPartners?: boolean;
};

export default function MapOverlayStats({
  stateLabel,
  villages,
  partners,
  superPartners,
  showSuperPartners = true,
}: Props) {
  const t = useTranslations("findpartner");
  const locale = useLocale(); // for number formatting (if needed later)

  return (
    <div
      className="
        absolute right-4 md:right-10 lg:right-16
        top-[28%] md:top-[26%]
        z-[39] w-[300px] md:w-[320px]
        rounded-xl bg-black/70 backdrop-blur-sm
        border border-white/10 shadow-xl p-5
        pointer-events-none
      "
      role="region"
    >
      {/* State Name */}
      <div
        className="text-[13px] font-semibold tracking-wide uppercase"
        style={{ color: "#F29A30" }}
      >
        {stateLabel}
      </div>

      {/* Stats */}
      <div className="mt-3 space-y-3">
        <div className="flex items-baseline justify-between">
          <span className="text-[12px] uppercase tracking-wide text-gray-200">
            {t("stat_villages")}
          </span>
          <span className="text-[18px] font-semibold text-white">
            {villages}
          </span>
        </div>

        <div className="flex items-baseline justify-between">
          <span className="text-[12px] uppercase tracking-wide text-gray-200">
            {t("stat_partners")}
          </span>
          <span className="text-[18px] font-semibold text-white">
            {partners}
          </span>
        </div>

        {showSuperPartners && (
          <div className="flex items-baseline justify-between">
            <span className="text-[12px] uppercase tracking-wide text-gray-200">
              {t("stat_super_partners")}
            </span>
            <span className="text-[18px] font-semibold text-white">
              {superPartners}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
